/**
 * Custom memo comparison — pan/zoom updates use refs and panupdate events, not re-renders.
 */
export function areMinimapPropsEqual(prevProps, nextProps) {
  const { pan: prevPan, zoom: prevZoom, ...prevRest } = prevProps;
  const { pan: nextPan, zoom: nextZoom, ...nextRest } = nextProps;

  const prevKeys = Object.keys(prevRest);
  const nextKeys = Object.keys(nextRest);

  if (prevKeys.length !== nextKeys.length) return false;

  for (const key of prevKeys) {
    if (prevRest[key] !== nextRest[key]) return false;
  }

  return true;
}
